import { create, useStore } from 'zustand'
import { callStore } from '@/shared/lib/livekit'
import type { RoomAccess } from './schema'

// Куда вернуть из комнаты: сотрудник — к встречам команды, заказчик — на свою
// витрину (общая ему закрыта гейтом), гость — на лендинг.
export type RoomExit = '/' | '/meetings' | '/my/meetings'

// room-JWT только в памяти вкладки — отдельный react-стор, без персиста.
interface RoomAccessState {
  roomAccess: RoomAccess | null
  returnTo: RoomExit
  setRoomAccess: (roomAccess: RoomAccess, returnTo?: RoomExit) => void
  clearRoomAccess: () => void
}

export const useRoomAccessStore = create<RoomAccessState>((set) => ({
  roomAccess: null,
  returnTo: '/meetings',
  setRoomAccess: (roomAccess, returnTo = '/meetings') => set({ roomAccess, returnTo }),
  clearRoomAccess: () => set({ roomAccess: null, returnTo: '/meetings' }),
}))

// React-биндинги над vanilla-стором фасада (медиа-состояние живёт вне React).
export const useCallStatus = () => useStore(callStore, (s) => s.status)
export const useCallDisconnectReason = () => useStore(callStore, (s) => s.disconnectReason)
export const useParticipants = () => useStore(callStore, (s) => s.participants)
export const useLocalMedia = () => useStore(callStore, (s) => s.localMedia)
export const useLocalMediaFailure = () => useStore(callStore, (s) => s.localMediaFailure)
export const useAudioBlocked = () => useStore(callStore, (s) => s.audioBlocked)
export const useActiveSpeakerIds = () => useStore(callStore, (s) => s.activeSpeakerIds)
export const useSpotlightId = () => useStore(callStore, (s) => s.spotlightId)
export const useSpeakerRank = () => useStore(callStore, (s) => s.speakerRank)
